<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th.text-left(width="10%")
          span(:title="$t('ui.working_date')") {{ $t('ui.short.working_date') }}
        th.text-left(width="10%")
          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
        th.text-left(width="7%" v-if="!isOperator")
          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
        th.text-left(width="7%")
          span(:title="$t('ui.inbox_id')") {{ $t('ui.inbox_id') }}
        th.text-left(width="7%")
          span(:title="$t('ui.vip_name')") {{ $t('ui.vip') }}
        th.text-left(width="10%")
          span(:title="$t('ui.rebate_mode')") {{ $t('ui.rebate_mode') }}
        th.text-right(width="7%")
          span(:title="$t('ui.rebate_rate')") {{ $t('ui.rebate_rate') }}
        th.text-center(width="7%")
          span(:title="$t('ui.rebate_type')") {{ $t('ui.rebate_type') }}
        th.text-right(width="10%")
          span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
        th.text-right(width="10%")
          span(:title="$t('ui.turnover_tier')") {{ $t('ui.turnover_tier') }}
        th.text-right(width="10%")
          span(:title="$t('ui.actual_rebate')") {{ $t('ui.actual_rebate') }}
        th.text-right(width="10%")
          span(:title="$t('ui.rounded_rebate')") {{ $t('ui.rounded_rebate') }}
        th.text-right(width="16%")
          span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(:colspan="12").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="$moment(item.working_date).format('YYYY-MM-DD')") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
        td.text-left
          span(:title="item.account_id") {{ item.account_id }}
        td.text-left(v-if="!isOperator")
          span(:title="item.parent_id") {{ item.parent_id }}
        td.text-left
          span(:title="item.inbox_id") {{ item.inbox_id }}
        td.text-left
          span(:title="item.vip_name") {{ item.vip_name }}
        td.text-left
          span(:title="item.rebate_mode") {{ item.rebate_mode }}
        td.text-right
          span(:title="item.rebate_rate") {{ item.rebate_rate }}
        td.text-center
          span(:title="item.rebate_type") {{ item.rebate_type }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.total_turnover)" :title="$n(item.total_turnover, 'currency')") {{ item.total_turnover != null ? $n(item.total_turnover, 'currency') : null }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.turnover_tier)" :title="$n(item.turnover_tier, 'currency')") {{ item.turnover_tier != null ? $n(item.turnover_tier, 'currency') : null }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.actual_rebate)" :title="$n(item.actual_rebate, 'currency')") {{ item.actual_rebate != null ? $n(item.actual_rebate, 'currency') : null }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.rounded_rebate)" :title="$n(item.rounded_rebate, 'currency')") {{ item.rounded_rebate != null ? $n(item.rounded_rebate, 'currency') : null }}
        td.text-right
          span(:title="$moment(item.action_date).format('YYYY-MM-DD HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD HH:mm:ss') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  watch: {
    tbl(newValue, oldValue) {
      //this.getTotal();
    },
  },
  mounted: function() {
    //this.getTotal();
  },
  methods: {
    clearTotal() {
    },
    getTotal: function() {
      //this.clearTotal();
    }
  }
};
</script>
